import React from 'react'

// prettier-ignore
export const PersonContact = {
  Create: React.lazy(() => import('./create')),
  Edit:   React.lazy(() => import('./edit')),
}
